/** PACKAGE IMPORTS */
import React, { useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { DataTableStyles, EmptyData, LoadingData } from '@/Theme';
import { DateTime } from 'luxon';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { AdminSvc } from '@/Services';

const List = ({
  listData,
  loading,
  handleView,
  count,
  size,
  setSize,
  page,
  setPage,
  setSort,
  setDirection,
  refreshData
}) => {
  const columns = useMemo(
    () => [

      {
        name: 'Created On',
        sortable: true,
        selector: row => row.created,
        cell: (row) => {
          return `${DateTime.fromISO(row.updated).toLocaleString(
            DateTime.DATETIME_SHORT
          )}`;
        },
      },
      {
        name: 'Total',
        selector: row => row.totalOrders,
      },
      {
        name: 'New',
        selector: row => row.newOrders,
      },
      {
        name: 'Skipped',
        selector: row => row.skippedOrders,
      },
      {
        name: 'Updated',
        selector: row => row.updatedOrders,
      },
      {
        name: 'Elasped',
        selector: row => row.elasped,
      },
      {
        name: 'Updated On',
        sortable: true,
        selector: row => row.updated,
        cell: (row) => {
          return `${DateTime.fromISO(row.updated).toLocaleString(
            DateTime.DATETIME_SHORT
          )}`;
        },
      },
			{
				name: '',
				width: '75px',
				cell: (row) => {
					return (
						<>
						<IconButton onClick={() => deleteLog(row)}>
              <DeleteIcon />
            </IconButton>
						</>
					);
				},
			},
    ],
    []
  );
  const handlePageChange = (p) => {
    setPage(p);
  };
  const handlePerRowsChange = (perPage, p) => {
    setSize(perPage);
    setPage(p);
  };
  const handleSort = (s, d) => {
    setSort(s.selector);
    setDirection(d);
  };
  const deleteLog = async (log) => {
		let response = await AdminSvc.deleteWixLog(log);
    if (response){
      refreshData();
    }

	};
  return (
    <>
      {loading && listData.length === 0 && <LoadingData />}
      {listData.length > 0 && <DataTable
        className='pagination-custom'
        columns={columns}
        data={listData}
        onRowClicked={handleView}
        highlightOnHover
        pointerOnHover
        customStyles={DataTableStyles}
        paginationDefaultPage={page}
        persistTableHead
        paginationPerPage={size}
        paginationRowsPerPageOptions={[10, 15, 25, 50, 100, 200, 500]}
        pagination
        paginationServer
        paginationTotalRows={count}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        defaultSortField='created'
        defaultSortAsc={false}
        onSort={handleSort}
        sortServer
        noHeader
        noDataComponent={
          <EmptyData />
        }
        noTableHead={(listData && listData.length <= 0)}
      />}
    </>
  );
};
export default List;
